import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=a601e61c&scoped=true&"
import script from "./Offer.vue?vue&type=script&lang=js&"
export * from "./Offer.vue?vue&type=script&lang=js&"
import style0 from "./Offer.vue?vue&type=style&index=0&id=a601e61c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a601e61c",
  null
  
)

export default component.exports